import { render, staticRenderFns } from "./RequestCodeModal.vue?vue&type=template&id=1a5f43e6&scoped=true&"
import script from "./RequestCodeModal.vue?vue&type=script&lang=ts&"
export * from "./RequestCodeModal.vue?vue&type=script&lang=ts&"
import style0 from "./RequestCodeModal.vue?vue&type=style&index=0&id=1a5f43e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f43e6",
  null
  
)

export default component.exports